import type React from 'react';

const Page: React.FC<React.PropsWithChildren> = ({ children }) => {
  return children;
};

export default Page;
